var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"content-container"},[_c(_vm.currentComponent,{key:_vm.$route.name,tag:"component"})],1),_c('NavInternal',{attrs:{"links":_vm.links}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }